import { render } from "./AddPhoneNumber.vue?vue&type=template&id=16dc4284&scoped=true"
import script from "./AddPhoneNumber.vue?vue&type=script&lang=js"
export * from "./AddPhoneNumber.vue?vue&type=script&lang=js"

import "./AddPhoneNumber.vue?vue&type=style&index=0&id=16dc4284&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dc4284"]])

export default __exports__